<template>
	<div
		v-if="canRenderCurrentRoute"
		class="app">
		<Navigation
			v-if="showNavigation"
			permanent />
		<main>
			<Suspense>
				<RouterView />
			</Suspense>
		</main>
		<Toast position="bottom-right" />
		<ConfirmDialog></ConfirmDialog>
	</div>
	<ProgressSpinner
		v-else
		class="app-loader" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import Navigation from '@/components/Navigation.vue'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import ProgressSpinner from 'primevue/progressspinner'
import { useAuth } from './composables/useAuth'

const { authStore } = useAuth()
const route = useRoute()

const canRenderCurrentRoute = computed(() => {
	if (!authStore.userReturned) {
		return false
	}

	if (route.meta.unprotected || route.meta.avoidUser) {
		return true
	}

	return !!authStore.user
})

const showNavigation = computed(() => !route.meta.noNavigation && !!authStore.user)
</script>

<style scoped lang="scss">
.app-loader {
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
.app {
	display: flex;
	flex-direction: row;
	height: 100vh;
	width: 100%;
	justify-content: center;
	max-height: 100vh;
	overflow: auto;

	main {
		flex: 1;
		max-height: 100vh;
		overflow: auto;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
}
</style>
